var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto",attrs:{"elevation":"2","outlined":"","max-width":"344"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"text-h4 mb-1",domProps:{"textContent":_vm._s(_vm.scoreCard.quantidade)}}),_c('div',{staticClass:"text-h5 mb-1",domProps:{"textContent":_vm._s(_vm.scoreCard.label)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }